import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function GiftMessage() {
    const { t } = useTranslation('gift');
    return (
        <Container>
            <Text color={colors.gray6}>
                {t('giftReceived.messageExample')}
            </Text>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-gray2);
    border-radius: 8px;
    margin: 0 auto 32px;
    padding: 24px 12px;
    width: calc(100% - 40px);
`;

export default GiftMessage;
